export enum CloudType {
  Azure = 'AZURE',
  Aws = 'AWS',
}
